import React, { useEffect, useRef, useState } from "react"
// import SimpleBar from "simplebar-react/dist"
import {
  Card,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  Button,
  Input,
  UncontrolledAlert,
} from "reactstrap"
import { Link } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import Spinners from "components/Common/Spinner"
import {
  allChatsData,
  ChatMessagesFetch,
  CommitteeChatMessagesFetch,
  CommitteeSendMessage,
  SendMessage,
  SetCurrentStaff,
  UpdateChatRead,
  UpdateChattingPerson,
} from "redux/slice/chats/chatSlice"
import { DateFormater, DateTimeFormatter } from "utilities/dateformater"
import { IoCheckmarkDoneSharp } from "react-icons/io5"
import Loader from "components/Common/loader"
import { SHUK_AUTH_PORTAL_TOKEN, SHUK_ROLE_VIWEWER } from "redux/enums"
import { getUserTokenID, parseJwt } from "utilities/parse-jwt"
import { userData } from "redux/slice/user/userSlice"

const CommitteeChat = props => {
  document.title = "Committee Chat | Shukre Ilahi"
  const dispatch = useDispatch()
  const { userRole } = useSelector(userData) 
  const {
    chatsUsersList,
    chatRoomMessages,
    staffId,
    loadingChats,
    loadingMessages,
    openChatRoom,
  } = useSelector(allChatsData)
  const [activeTab, setactiveTab] = useState("1")
  const [curMessage, setcurMessage] = useState("")
  const [searchedText, setSearchedText] = useState("")
  const [searchedUsers, setSearchedUsers] = useState([])
  const [isUserListVisible, setIsUserListVisible] = useState(true)
  const [isSmallScreen, setIsSmallScreen] = useState(false)

  const isViewer = userRole === SHUK_ROLE_VIWEWER
  
  // console.log("chatRoomMessages", chatRoomMessages)
  const fetchRoomMessages = async () => {
    dispatch(CommitteeChatMessagesFetch({}))
      .then(res => {})
      .catch(error => {
        console.log("error", error)
      })
  }

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setactiveTab(tab)
    }
  }

  // useEffect(()=>{
  //   console.log("curMessage changes", curMessage)
  // }, [curMessage])

  const currentTime = new Date().toISOString()
  // const hours = currentTime.getHours()
  // const minutes = currentTime.getMinutes()
  // const time = `${hours}: ${minutes}`
  const sendNewMessage = async () => {
    try {
      // console.log("currentTime", currentTime)
      let _staffId = ""
      if (staffId) {
        _staffId = staffId
      } else {
        _staffId = await getUserTokenID()
      }
      if (curMessage !== "" && staffId) {
        let data = {
          // studentId: openChatRoom?.studentId,
          staffId: staffId || _staffId,
          communicationJson: {
            userId: staffId || _staffId,
            message: curMessage,
            time: currentTime,
            isRead: false,
          },
        }
        // console.log("message data", data)
        await dispatch(CommitteeSendMessage(data))
          .then(result => {
            // console.log("result of send api", result)
            if (result?.payload?.status === 200) {
              setcurMessage("")
              fetchRoomMessages()
            }
          })
          .catch(err => {
            console.log("message sending error", err)
          })
      }
    } catch (error) {
      console.log(error)
    }
  }

  // const onKeyPress = e => {
  //   const { key, value } = e
  //   if (key === "Enter") {
  //     setcurMessage(value)
  //     // setDisable(true)
  //     sendNewMessage()
  //   }
  // }

  //serach users
  // const searchUsers = () => {
  //   try {
  //     // console.log("search text", searchedText)
  //     if (searchedText !== "") {
  //       let searchedData = chatsUsersList.filter(item =>
  //         item?.studentName?.toLowerCase().includes(searchedText.toLowerCase()),
  //       )
  //       setSearchedUsers(searchedData)
  //     } else {
  //       setSearchedUsers(chatsUsersList)
  //     }
  //   } catch (err) {
  //     console.log("error", err)
  //   }
  // }

  // useEffect(() => {
  //   searchUsers()
  // }, [searchedText, chatsUsersList])

  const [deleteMsg, setDeleteMsg] = useState("")
  const toggle_deleMsg = id => {
    setDeleteMsg(!deleteMsg)
    // dispatch(onDeleteMessage(id))
  }

  const [copyMsgAlert, setCopyMsgAlert] = useState(false)
  const copyMsg = ele => {
    var copyText = ele
      .closest(".conversation-list")
      .querySelector("p").innerHTML
    navigator.clipboard.writeText(copyText)
    setCopyMsgAlert(true)
    if (copyText) {
      setTimeout(() => {
        setCopyMsgAlert(false)
      }, 1000)
    }
  }

  // scroll simple bar
  const scrollRef = useRef(null)
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight
    }
  }, [chatRoomMessages])

  useEffect(() => {
    // findingCurrentUser();
    let refreshTimeout
    refreshTimeout = setInterval(() => {
      console.log("comitte refreshing messages")
      fetchRoomMessages()
    }, 90000)
    return () => {
      if (refreshTimeout) {
        console.log("interval ending...")
        clearInterval(refreshTimeout)
      }
    }
  }, [])

  const settingStaffId = async () => {
    let userId = await getUserTokenID()
    dispatch(SetCurrentStaff(userId))
  }

  useEffect(() => {
    settingStaffId()
    fetchRoomMessages()
  }, [chatsUsersList])

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window?.innerWidth <= 768)
      if (window?.innerWidth > 768) {
        setIsUserListVisible(true)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <React.Fragment>
      <div className="chat-ui">
        {/* {(isSmallScreen ? isUserListVisible : true) && (
          <div className="user-list">
            <div className="p-3">
              <div className="search-box position-relative">
                <Input
                  type="text"
                  onChange={e => setSearchedText(e.target.value)}
                  className="form-control rounded border"
                  placeholder="Search..."
                />
                <i className="mdi mdi-magnify search-icon"></i>
              </div>
            </div>
            <h5 className="font-size-14 mb-3">Recent</h5>
            <ul>
              {loadingChats ? (
                <Loader />
              ) : (
                <SimpleBar>
                  {searchedUsers.map(chat => (
                    <li
                      key={chat?.studentId}
                      className={
                        openChatRoom.studentId === chat.studentId
                          ? "active"
                          : "non-active"
                      }
                    >
                      <Link
                        onClick={() => {
                          fetchRoomMessages(chat)
                          if (isSmallScreen) setIsUserListVisible(false)
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1 overflow-hidden">
                            <h5 className="text-truncate font-size-15 mb-0">
                              {chat.studentName}
                            </h5>
                          </div>
                          {
                            !chat?.isRead ? 
                            <div className="flex-shrink-0 ms-3">
                              <span className="position-absolute start-80 translate-middle p-1 bg-danger border border-light rounded-circle">
                                <span className="visually-hidden">New alerts</span>
                              </span>
                            </div> : null
                          }
                        </div>
                      </Link>
                    </li>
                  ))}
                </SimpleBar>
              )}
            </ul>
          </div>
        )} */}

        <div className="chat-box">
          <header className="chat-header">
            {/* {isSmallScreen && (
              <button
                className="toggle-users"
                onClick={() => setIsUserListVisible(!isUserListVisible)}
              >
                ☰
              </button>
            )} */}
            {/* {chatRoomMessages && openChatRoom?.studentName ? ( */}
            <div className="flex-grow-1">
              <h5 className="font-size-16 mb-1 text-truncate fw-bold">
                {/* <p className="text-reset"> */}
                Committee Chat
                {/* </p> */}
              </h5>
              {/* <p className="text-muted text-truncate mb-0">Online</p> */}
            </div>
            {/* ) : (
              <div className="flex-grow-1" style={{ minHeight: "40px" }}></div>
            )} */}
          </header>

          <div className="message-box" ref={scrollRef}>
            {loadingMessages ? (
              <Loader />
            ) : (
              <ul className="list-unstyled mb-0">
                {chatRoomMessages &&
                  [...chatRoomMessages]?.reverse().map((userMsg, index) => {
                    return (
                      <li
                        key={index}
                        className={userMsg?.userId !== staffId ? "" : "right"}
                      >
                        <div className="conversation-list">
                          <div className="d-flex">
                            {userMsg?.images && (
                              <img
                                src={userMsg?.images}
                                className="rounded-circle avatar"
                                alt=""
                              />
                            )}
                            <div className="flex-1 ms-3">
                              {/* <div className="d-flex justify-content-between">
                              </div> */}
                              <div className="ctext-wrap">
                                <div className="ctext-wrap-content">
                                  {chatRoomMessages &&
                                  openChatRoom?.studentName &&
                                  userMsg?.userId !== staffId ? (
                                    <p className="fw-bold text-secondary-si">
                                      {openChatRoom?.studentName}
                                    </p>
                                  ) : (
                                    <p className="fw-bold text-secondary-si">
                                      {userMsg?.userName
                                        ? userMsg.userName
                                        : ""}
                                    </p>
                                  )}
                                  <p
                                    className="mb-0"
                                    style={{
                                      whiteSpace: "pre-wrap",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {userMsg?.message}
                                  </p>
                                  {userMsg?.time !== 0 && (
                                    <span className="msg-time fw-normal ">
                                      {userMsg?.time
                                        ? DateTimeFormatter(userMsg?.time)
                                        : ""}{" "}
                                      {userMsg?.userId === staffId && (
                                        <IoCheckmarkDoneSharp
                                          size={20}
                                          color={userMsg?.isRead ? "blue" : ""}
                                        />
                                      )}
                                    </span>
                                  )}
                                </div>
                                {/* <UncontrolledDropdown className="align-self-start">
                                  <DropdownToggle tag="a">
                                    <i className="bx bx-dots-vertical-rounded"></i>
                                  </DropdownToggle>
                                  <DropdownMenu>
                                    <DropdownItem
                                      onClick={e => copyMsg(e.target)}
                                    >
                                      Copy
                                    </DropdownItem>
                                    <DropdownItem>Save</DropdownItem>
                                    <DropdownItem>Forward</DropdownItem>
                                    <DropdownItem
                                      onClick={e => toggle_deleMsg(userMsg.id)}
                                    >
                                      Delete
                                    </DropdownItem>
                                  </DropdownMenu>
                                </UncontrolledDropdown> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    )
                    // })
                  })}
              </ul>
            )}
          </div>

          {
            !isViewer && (
              <div className="p-3 border-top bg-light">
                <div className="row">
                  <div className="col">
                    <div className="position-relative">
                      <textarea
                        type="text"
                        row={6}
                        value={curMessage}
                        // onKeyPress={onKeyPress}
                        onChange={e => {
                          setcurMessage(e.target.value)
                          // setDisable(true)
                        }}
                        // onKeyDown={e => {
                        //   if (e.key === "Enter") {
                        //     sendNewMessage()
                        //   }
                        // }}
                        className="form-control border chat-input"
                        placeholder="Enter Message..."
                      />
                    </div>
                  </div>
                  <div className="col-auto d-flex justify-content-center align-items-end mb-1">
                    <Button
                      type="button"
                      // color="primary"
                      // disabled={!isdisable}
                      disabled={!curMessage}
                      onClick={sendNewMessage}
                      className="chat-send w-md waves-effect waves-light"
                    >
                      <span className="d-none d-sm-inline-block me-2">Send</span>{" "}
                      <i className="mdi mdi-send float-end"></i>
                    </Button>
                  </div>
                </div>
              </div>
            )
          }

        </div>
      </div>
    </React.Fragment>
  )
}

export default CommitteeChat
